module.exports = __webpack_public_path__ + "media/images/pc/icon-star-2c7f4301668daf53344d85fd19f41834.png";